/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: requesttypes.components.ts
 * Generated By : ianday on 12/12/23
 * Date ........: 12/12/23
 /************/

import {Component, OnInit, ViewChild, HostListener, AfterContentInit} from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import {MatSort} from '@angular/material/sort';
import {Settings} from '../../../services/settings';
import { ServiceRequestType} from "../../../models/service-request-type";
import { ServiceRequestsService } from "../../../services/service-requests.service";
import {ValidationResult} from '../../../models/validation-result';
import {
    ConfirmDialogComponent,
    ConfirmDialogModel
} from '../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {TransactionHistoryService} from '../../../services/transactionhistory.service';
import {TransactionHistoryComponent} from '../../../components/transaction-history/transaction-history';
import {DwUtils} from '../../../components/utils/dw-utils';
import {RequestStatus} from "../../../models/request-status";
import {StatusReasons} from "../../../models/status-reasons";
import {dataRecord} from "../../requests/requests.component";

@Component({
    selector: 'app-status-reasons',
    templateUrl: './status-reasons.component.html',
    styleUrls: ['./status-reasons.component.css']
})
export class StatusReasonsComponent implements OnInit, AfterContentInit {

    /*** Header / Query Strip Variables ****/
    public formTitle = 'Status Reasons';
    public pagination: string;

    /*** Editing variables ***/
    public isEditing: boolean | null = false;
    public isAdd: boolean | null = false;
    public records: any;
    public selectedRecord: any;
    public historyRecord: any;
    public Idx: number | null = -1;
    public strErr: string | null = '';
    public dataSource: MatTableDataSource<any>;
    public finalizeList: any;
    public result: boolean | null = false;
    public disabledFlag: boolean | null = true;

    /**** Query strip filter settings ***/
    public selectedStatusFilter: string | null = 'Active';
    public contentClassWithBanner: string | null = 'dwtable-container';
    public contentClassWithoutBanner: string | null = 'dwtable-container-without-header';
    public contentClassName: string | null = 'dwtable-container';

    /*** Record Table / card table  ***/
    public displayedColumns: string[] = ['id', 'statusDescription', 'description', 'activeStatus'];

    /***** Control Strip Button Visibility ***/
    public visibleAdd: boolean | null = false;
    public visibleModify: boolean | null = false;
    public visibleDelete: boolean | null = false;

    /***** Tab Detail Section *****/
    public selectedTabIndex: number | null = 0;

    public id: any | null = '';
    public description: any | null = '';
    public activeStatus: any | null = '';
    public requestStatusId: any | null = '';
    public busyCursor: boolean = false;

    public requestStatusList: any;
    
    public selectable: any = '';

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild('history', {static: true}) history: TransactionHistoryComponent;

    constructor(private serviceRequestsService: ServiceRequestsService,
                private txService: TransactionHistoryService,
                public dialog: MatDialog) {
        this.selectedRecord = new StatusReasons();
    }

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege("SETTINGS_STATUS_REASONS", "WRITE")) {
            this.visibleAdd = true;
            this.visibleModify = true;
            this.visibleDelete = false;
        }
    }

    public ngAfterContentInit() {

        this.queryStatusRecords();

        if (Settings.getInstance().enableMessageBanner) {
            this.contentClassName = this.contentClassWithBanner;
        } else {
            this.contentClassName = this.contentClassWithoutBanner;
        }
    }
    public queryStatusRecords(): void {

        this.busyCursor = true;
        this.requestStatusList = [];
        this.serviceRequestsService.getAllRequestStatuses().subscribe(
            (data) => {
                this.busyCursor = false;

                /*** drawing attention to this
                    weed out:Approved / UnMatched / Matched
                    please replace with a proper method!
                ***/

                for(const rec of data) {
                    if(rec.id < 4) {
                        continue
                    }

                    this.requestStatusList.push(new dataRecord(rec.id, rec.shortDescription));
                }
                this.queryRecords();
            },
        (error) => {
            Settings.getInstance().handleError(error,
                'Error: unable to retrieve request status data from the service');
            this.busyCursor = false;
        });

    }
    /*** Query Records from the Service ***/
    public queryRecords() {
        this.busyCursor = true;
        this.records = [];
        this.serviceRequestsService.getAllStatusReasons().subscribe(
            (result) => {
                this.busyCursor = false;

                for (let rec of result) {

                    const st = this.requestStatusList.find(s => s.id === rec.requestStatusId);

                    if(st !== null) {
                        rec['statusDescription'] = st.description;
                    }
                    this.records.push(rec);
                }
                this.records = this.records.sort((a, b) => a.id - b.id);
                this.dataSource = new MatTableDataSource(this.records);
                this.dataSource.sort = this.sort;

                this.setPagination(-1, this.dataSource.data.length);
                this.onChangeStatusFilterValue();
            },
            (error) => {
                Settings.getInstance().handleError(error,'Error: unable to retrieve status reasons from the' +
                    ' service');
                this.busyCursor = false;
            }
        );
    }
    /*** Display the number of records from the total ***/
    public setPagination(idx: number, total: number) {
        this.pagination = (idx + 1) + '/' + total;
    }
    public onChangeStatusFilterValue() {
        const dataTemp: StatusReasons[] = [];
        this.clearFilter();

        for (const rec of this.records) {
            if (rec.activeStatus === this.selectedStatusFilter || this.selectedStatusFilter === 'All') {
                dataTemp.push(rec);
            }
        }
        this.dataSource = new MatTableDataSource(dataTemp);
        this.setPagination(-1, this.dataSource.filteredData.length);
    }
    public onStatusChange(record:StatusReasons) {
		let rec: StatusReasons = new StatusReasons();
		rec.id= record.id;
		rec.activeStatus = record.activeStatus;
		rec.description = record.description;
		rec.requestStatusId = record.requestStatusId;
        this.serviceRequestsService.updateStatusReason(rec).subscribe(
            () => {
                // no user feedback, just apply the filter ...
                const previousRecord = { ...this.selectedRecord };
				previousRecord.activeStatus = this.selectedRecord.activeStatus === "Active" ? "Inactive" : "Active";
				this.txService.updateTransactionHistory(previousRecord,
					this.selectedRecord, 'StatusReasons', this.selectedRecord.id);
                this.onChangeStatusFilterValue();
                this.onChangeStatusFilterValue();
            });
    }
    public doTabChange(): void {

    }
    @HostListener('matSortChange', ['$event'])
    public onSortChange(event: any) {

        if (event.direction === 'asc') {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    a[event.active] - (b[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    a[event.active].localeCompare(b[event.active]));
            }
        } else {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    b[event.active] - (a[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    b[event.active].localeCompare(a[event.active]));
            }
        }

        this.dataSource.data = this.records;
        this.onChangeStatusFilterValue();
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public clearFilter() {
        if (this.isEditing) {
            return;
        }
        this.unSelectRow();
        this.dataSource.filter = '';
        this.selectRow();
        this.setPagination(-1, this.dataSource.data.length);
    }
    public applyFilter(filterValue: string) {
        if (this.isEditing) {
            return;
        }
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.unSelectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public selectRow() {
        if (this.selectedRecord.id === 0) {
            this.unSelectRow();
            return;
        }
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public unSelectRow() {

        this.Idx = -1;
        this.selectedRecord = new StatusReasons();
        this.setPagination(this.Idx, this.dataSource.data.length);
        this.displayDetail(this.selectedRecord);

    }
    public displayDetail(record: any) {
        if (record === undefined) {
            return;
        }
        this.id = record.id;
        this.description = DwUtils.capitalize(record.description);
        this.requestStatusId = record.requestStatusId;
        this.activeStatus = record.activeStatus;
        this.selectable = record.selectable==1?'Yes':'No';
        this.history.onShowHandler('StatusReasons', 'id', record.id.toString());
    }
    public clear() {
        this.id = '';
        this.description = '';
        this.activeStatus = '';
        this.selectable = 'Yes'
    }
    public addModifyRecord(isAdd: boolean) {
        this.isAdd = isAdd;
        this.isEditing = true;
        this.selectedTabIndex = 0;


        if (this.isAdd) {
            this.clear();
            this.id = 0;
            this.requestStatusId = 0;
            this.activeStatus = 'Active';
            this.selectable = 'Yes'
        } else {
            // store the history record
            this.historyRecord = this.selectedRecord;
        }

        DwUtils.setFocus('description');
    }
    public removeRecord() {
        const message = 'Remove Request Status: "' + this.selectedRecord.description + '" - Are you sure?';
        const dialogData = new ConfirmDialogModel('Please Confirm', message);

        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: dialogData,
            panelClass: 'custom-dialog-container'
        });

        dialogRef.afterClosed().subscribe(dialogResult => {
            this.result = dialogResult;
            if (this.result === true) {
                this.serviceRequestsService.deleteStatusReason(this.selectedRecord.id).subscribe(
                    () => {
                        // remove the row from the table.

                        this.records.splice(this.Idx, 1);
                        this.dataSource.data = this.records;
                        this.clear();
                    },
                    (error) => {
                        Settings.getInstance().handleError(error);
                    });
            }
        });
    }
    public tableKeyDown(event: KeyboardEvent) {
        if (this.isEditing) {
            return;
        }

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
                this.displayDetail(this.selectedRecord);
            }
        }
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
    }
    public validateFields(): boolean {

        this.strErr = '';
        const vr: ValidationResult = this.selectedRecord.validateRecord();

        if (vr.error.length > 0) {
            this.strErr = vr.error;
            DwUtils.setFocus(vr.focus_field);
            return false;
        }
        return true;
    }
    public submitRecord() {

        this.selectedRecord = new StatusReasons();
        this.selectedRecord.id = this.id;
        this.selectedRecord.description = DwUtils.capitalize(this.description);
        this.selectedRecord.requestStatusId = this.requestStatusId
        this.selectedRecord.activeStatus = this.activeStatus;
        this.selectedRecord.selectable = this.selectable=='Yes'?1:0;

        this.strErr = '';

        if (!this.validateFields()) {
            return;
        }
        if (this.isAdd === true) {
            this.serviceRequestsService.createStatusReason(this.selectedRecord).subscribe(
                (result) => {
                    this.selectedRecord.id = result.id;
                    this.isEditing = false;
                    /*** add a transaction history record ***/
                    this.txService.createTransactionHistory('StatusReasons', this.selectedRecord.id);
                },
                () => {
                    this.strErr = 'Error: The server could not add/submit this record';
                    return;
                }
            );
        } else {

            this.serviceRequestsService.updateStatusReason(this.selectedRecord).subscribe(
                () => {
                    this.isEditing = false;
                },
                () => {
                    this.strErr = 'Error: The server could not update this record';
                    this.selectedRecord = this.historyRecord;
                    return;
                });

            /*** add a transaction history record ***/
            this.txService.updateTransactionHistory(this.historyRecord,
                this.selectedRecord, 'StatusReasons', this.selectedRecord.id);
        }
        this.updateSelectedRow(this.selectedRecord);
    }
    /* Update the record in the table's data source - without refreshing it */
    public updateSelectedRow(selected: any ): void {

        const statusDescription =
                this.requestStatusList.find(s => s.id === selected.requestStatusId).description;
        selected['statusDescription'] = statusDescription;

        if (this.isAdd === true) {
            // add the new record to the top.

            this.records.unshift(selected);
            this.dataSource.data = this.records;
            this.onChangeStatusFilterValue();
            this.Idx = 0;
        } else {
            const i: number = this.records.findIndex(r => r.id === selected.id);
            this.records[i] = selected;
            this.dataSource.data = this.records;
            this.onChangeStatusFilterValue();
            this.selectRow();
            this.setPagination(this.Idx, this.dataSource.filteredData.length);
        }
        //this.dataSource.sort = this.sort;
    }
    public onRowClicked(selected: any) {

        if (this.isEditing === true)
            return;

        this.selectedRecord = selected;
        this.selectRow();
        this.setPagination(this.Idx, this.dataSource.filteredData.length);
        this.displayDetail(this.selectedRecord);
    }
    public cancelSubmitRecord() {
        this.strErr = '';
        this.isEditing = false;
        this.displayDetail(this.selectedRecord);
    }
}
